import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Avatar from "./Avatar";
import AccountInfoBar from "./AccountInfoBar";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

import {
	makeStyles,
	Card,
	CardContent,
	CardActions,
	Typography,
	Button,
	Grid
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	card: {
		borderRadius: 0,
		minWidth: 250,
		maxWidth: 250,
		backgroundColor: theme.palette.primary.darkBlue,

		[theme.breakpoints.up('md')]: {
			backgroundColor: theme.palette.primary.grey
		}
	},

	avatarWrapper: {
		display: "flex",
		justifyContent: "center"
	},

	typography: {
		color: theme.palette.primary.grey,

		[theme.breakpoints.up('md')]: {
			color: theme.palette.primary.black
		}
	},

	typographyWrapper: {
		paddingTop: theme.spacing(2)
	},

	actions: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		paddingTop: theme.spacing(2)
	},

	content: {
		paddingBottom: `0px !important`
	},

	button: {
		textTransform: "none"
	},

	infoGridItem: {
		maxWidth: 175
	}
}));

function ProfileCard(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	const close = () => {
		let {closeHandler} = props;
		if (closeHandler) {
			closeHandler();
		}
	};

	const profileClickHandler = () => {
		let {history} = props;
		close();
		history.push(`/profile/${authenticatedUser.id}`);
	};

	const signOut = () => {
		close();
		props.history.push("/logout");
	};

	const unghost = () => {
		close();
		window.location.replace("/accounts/users/unghost");
	};

	let classes = styles(),
		{avatarSizeFactor, location} = props;

	return (
		<Card elevation={0} className={`${classes.card}`}>
			<CardContent className={classes.content}>
				<Grid
					container
					wrap="nowrap"
					justify="flex-start"
					alignItems="center"
					direction={"column"}>
					<Grid item className={classes.avatarWrapper}>
						<Avatar
							sizeFactor={avatarSizeFactor || 2}
							authorName={authenticatedUser.name}
							authorImage={authenticatedUser.avatar} />
					</Grid>
					<Grid item className={`${classes.infoGridItem} ${classes.typographyWrapper}`}>
						<Typography
							align="center"
							className={classes.typography}>{authenticatedUser.name}</Typography>
						<Typography
							noWrap
							align="center"
							variant="caption"
							className={classes.typography}>{authenticatedUser.title}</Typography>
						<AccountInfoBar
							location={location}
							user={authenticatedUser}
							className={classes.typography}
							showId={authenticatedUser.ghosting} />
						<CardActions className={classes.actions}>
							<Button
								color="primary"
								className={classes.button}
								onClick={profileClickHandler}>Manage Your Profile</Button>
							<Button
								color="primary"
								className={classes.button}
								onClick={signOut}>Sign Out</Button>
							{authenticatedUser.ghosting ?
								<Button
									color="primary"
									className={classes.button}
									onClick={unghost}>Unghost</Button>
								: null
							}
						</CardActions>
					</Grid>
				</Grid>
			</CardContent>
			{/*<AccountInfoBar
				accountName={authenticatedUser.accountName}
				accountId={authenticatedUser.ghosting ? authenticatedUser.accountId : null} />*/}
		</Card>
	);
}

ProfileCard.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object,
	closeHandler: PropTypes.func,
	avatarSizeFactor: PropTypes.number
};

export default ProfileCard;
